'use client'

import { Fragment } from 'react'
import type { SearchAutocompletePromotion } from './searchAutocompletePromotions'
import { PromotedSearchItem } from './PromotedSearchItem'

interface PromotedSearchListProps {
  promotions: SearchAutocompletePromotion[]
  activeIndex: number | null
  onClick: () => void
  onMouseEnter: (index: number) => void
  onMouseLeave: () => void
  className?: string
}

export function PromotedSearchList({
  promotions,
  activeIndex,
  onClick,
  onMouseEnter,
  onMouseLeave,
  className = 'border-b border-gray-200',
}: PromotedSearchListProps) {
  return (
    <div className={className}>
      {promotions.map((promo, index) => (
        <Fragment key={promo.id}>
          {index > 0 && promo.tier !== promotions[index - 1].tier && (
            <div className="border-t border-gray-200" aria-hidden />
          )}
          <PromotedSearchItem
            promotion={promo}
            isActive={activeIndex === index}
            onClick={onClick}
            onMouseEnter={() => onMouseEnter(index)}
            onMouseLeave={onMouseLeave}
          />
        </Fragment>
      ))}
    </div>
  )
}
